<script>
    import api from '../../api';

    import {bootstrapDangerGrowl as errorGrowl} from "../../../../Util/growler";

    import LoadingBox from "../../../../Components/Util/LoadingBox.vue";
    
    export default {
        created() {
            const vm = this;

            api.listNewsroomItems().then(
                newsroomItems => vm.newsroomItems = newsroomItems,
                err => errorGrowl(err)
            );
        },
        render(createElement, context) {
            if(!this.newsroomItems){
                return createElement(LoadingBox);
            }

            const slotContent = this.$scopedSlots.default({
                newsroomItems: this.newsroomItems
            });
            
            //Wrap content in fragment to prevent having multiple elements in root
            return createElement('fragment', slotContent);
        },
        data: () => ({
            newsroomItems: null
        })
    }
</script>